export const FORM_URL_ENCODED_HEADERS_CONF = { 
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
};

export const FORM_MULTI_HEADERS_CONF = { 
    headers: {
        'Content-Type': 'multipart/form-data',
    }
};